import { type FC, type ReactNode, useRef } from 'react'
import { IntlProvider } from 'react-intl'

import en from './en.json'
import fr from './fr.json'

export const L10NProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const locale = useRef(new URLSearchParams(document.location.search).get('lang') ?? 'fr')
  return (
    <IntlProvider locale={locale.current} defaultLocale="fr" messages={locale.current === 'en' ? en : fr}>
      {children}
    </IntlProvider>
  )
}
